module.exports = __webpack_public_path__ + "static/media/ont.d3eaadb3.svg";